import React, { useState, useRef, useLayoutEffect, useEffect } from "react";

import { Row, Col, Input, Select, Form, message, Button, Spin } from "antd";
import { Margin } from "styled-components-spacing";
import Center from "react-center";
import { API_URL } from "../../../../constants";
import useAxios from "@use-hooks/axios";
import isEmail from "validator/lib/isEmail";
// CSS Files
import "../../../Fonts/Fonts.css";
import "../../../Statics/Common/FontStyle.css";
import "../../../Statics/ContactUs/Contact/ContactUs.css";

const { Option } = Select;
const { TextArea } = Input;

const contactUsFormCard = {
  borderRadius: "20px",
  backgroundColor: "#fff",
  opacity: "95%",
  boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
};
const contactInput = {
  textAlign: "right",
  direction: "rtl",
  paddingRight: "30px",
  fontFamily: "IranSans",
  fontSize: ".9em",
  borderRadius: "15px",
};
const contactInputTablet = {
  textAlign: "right",
  direction: "rtl",
  paddingRight: "30px",
  fontFamily: "IranSans",
  fontSize: ".85em",
  borderRadius: "15px",
};
const contactInputMobile = {
  textAlign: "center",
  direction: "rtl",
  fontFamily: "IranSans",
  fontSize: ".8em",
  borderRadius: "15px",
};
const contactSelect = {
  width: "100%",
  fontFamily: "IranSans",
  color: "rgb(122, 121, 121)",
  borderColor: "#333",
  textAlign: "center",
};

const contactSelectMobile = {
  width: "100%",
  fontFamily: "IranSans",
  color: "rgb(122, 121, 121)",
  borderColor: "#333",
  textAlign: "center",
  fontSize: ".8em",
};
const contactTextArea = {
  fontFamily: "IranSans",
  color: "#333",
  direction: "rtl",
  textAlign: "right",
  borderRadius: "15px",
};
const ContactText = {
  fontSize: ".7em",
  fontFamily: "IranSans",
  textAlign: "center",
  direction: "rtl",
  lineHeight: 1.5,
  color: "#535353",
  paddingRight: "20px",
  paddingLeft: "20px",
};
const ContactTextTablet = {
  fontSize: ".85em",
  fontFamily: "IranSans",
  textAlign: "center",
  direction: "rtl",
  lineHeight: 1.5,
  color: "#535353",
  paddingRight: "20px",
  paddingLeft: "20px",
};
const ContactTextMobile = {
  fontSize: ".8em",
  fontFamily: "IranSans",
  textAlign: "center",
  direction: "rtl",
  lineHeight: 1.5,
  color: "#535353",
  paddingRight: "20px",
  paddingLeft: "20px",
};

function handleChange(value) {
  console.log(`selected ${value}`);
}
const CentralAddress = (props) => {
  const [form] = Form.useForm();
  const [postvalues, setPostValues] = useState();
  const [loading, setLoading] = useState(false);

  const postContact = useAxios({
    url: `${API_URL}/Contact_Service/`,
    method: "POST",
    options: {
      data: postvalues,
    },
    // trigger: postvalues,

    // forceDispatchEffect: () => !!postvalues,
    customHandler: (err, res) => {
      if (res) {
        console.log("rest", res);
        message.success("پیام شما با موفقیت ذخیره شد ");
        setLoading(false);
        form.resetFields();
      }
    },
  });

  useEffect(() => {
    postContact.reFetch();
  }, [postvalues]);

  const isNumeric = (rule, value) => {
    if (!isNaN(value)) return Promise.resolve();

    return Promise.reject("لطفا عدد وارد نمایید");
  };

  const onFinish = (values) => {
    console.log(values);
    const formData = new FormData();
    if (isEmail(values.email)) {
      if (values.phone.length == 11) {
        formData.append("first_and_last_name", values.name);
        formData.append("email", values.email);

        formData.append("phone_number", values.phone);

        formData.append("message", values.message);
        formData.append("type", values.type);

        setPostValues(formData);
      } else {
        message.error("شماره موبایل معتبر نیست");
      }
    } else {
      message.error("پست الکترونیک را وارد نمایید");
    }
  };

  const firstUpdate = useRef(true);
  useLayoutEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
    console.log("here");

    setLoading(true);
  }, [postvalues]);
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return props.size === "laptopdesktop" ? (
    <div className="ContactUsBackground">
      <div style={{ paddingTop: "100px" }}>
        <Center>
          <p className="mainTitle mainTitleBorderRight mainTitleBorderLeft">
            <strong>ارتباط با ما</strong>
          </p>
        </Center>
      </div>
      <Row style={{ marginTop: "100px" }}>
        <Col span={5}></Col>
        <Col span={14}>
          <div style={contactUsFormCard}>
            <Row>
              <Col span={10}>
                <div
                  style={{
                    backgroundColor: "#f5f5f5",
                    borderTopLeftRadius: "20px",
                  }}
                >
                  <Center>
                    <img
                      style={{ marginTop: "20px", width: "15%" }}
                      src={require("../../../Imgs/ContactUs/Location.png")}
                    />
                  </Center>
                  <Margin top={2}></Margin>
                  <Center>
                    <strong
                      style={{
                        fontSize: ".85em",
                        fontFamily: "IranSans",
                        textAlign: "right",
                        direction: "rtl",
                        lineHeight: 1.5,
                        color: "#535353",
                      }}
                    >
                      آدرس :
                    </strong>
                  </Center>
                  <Margin top={2}></Margin>
                  <Center>
                    <p style={ContactText}>
                    ۱-ساختمان دفتر مديرعامل و معاونت نواوري و اقتصادي
تهران :
<br/>
يوسف آباد، بالاتر از ميدان سلماس خيابان شهريار نبش خيابان چهاردهم  پلاك ٣٩ 
                    </p>
                  </Center>
                  <Center>
                    <p style={ContactText}>

                    ۲.ساختمان معاونت فني و امور مشتريان:
                    <br/>
تهران:يوسف آباد ، خيابان اسد آبادي نبش خيابان چهارم پلاک ۴۴                    </p>
                  </Center>
                  <Center>
                    <p style={ContactText}>
                    ۳-ساختمان اداری:
                    <br/>
 یوسف آباد خیابان اسدآبادی کوچه هفتم پلاک ۱۴ 

                    </p>
                  </Center>
                  <Center>
                    <p style={ContactText}>
                      ۴-ساختمان مرکزی:
                      <br/>
                      مطهری ، کوه نور ، انتهای خیابان چهارم و ششم  پلاک ۱۵  و ۱۶ (تعطیل به علت ساخت و ساز)
                    </p>
                  </Center>
                  <Center>
                  <p style={ContactText}>
                      ۵-ساختمان فاطمی:
                      <br/>
                      فاطمی کوچه دوم جنب بیمه ایران پلاک ۱۳
                    </p>
                  </Center>
                  <Margin top={2}></Margin>
                  <Center>
                    <img
                      style={{ width: "15%" }}
                      src={require("../../../Imgs/ContactUs/phone.png")}
                    />
                  </Center>
                  <Margin top={2}></Margin>
                  <Center>
                    <strong
                      style={{
                        fontSize: ".85em",
                        fontFamily: "IranSans",
                        textAlign: "right",
                        direction: "rtl",
                        lineHeight: 1.5,
                        color: "#535353",
                      }}
                    >
                      تلفن تماس:
                    </strong>
                  </Center>
                  <Margin top={2}></Margin>
                  <Center>
                    <p style={ContactText}>021-84228</p>
                  </Center>
                  <Center style={{ marginTop: "-12.5px" }}>
                    <p style={ContactText}>( هزار خط ) 999 الی 84229000-021</p>
                  </Center>
                  <Center style={{ marginTop: "-12.5px" }}>
                    <p style={ContactText}>فکس : ۵-۸۸۵۵۲۰۸۴-۰۲۱</p>
                  </Center>
                  <Margin top={2}></Margin>
                  <Center>
                    <img
                      style={{ width: "15%" }}
                      src={require("../../../Imgs/ContactUs/support.png")}
                    />
                  </Center>
                  <Margin top={2}></Margin>
                  <Center>
                    <strong
                      style={{
                        fontSize: ".85em",
                        fontFamily: "IranSans",
                        textAlign: "right",
                        direction: "rtl",
                        lineHeight: 1.5,
                        color: "#535353",
                      }}
                    >
                      مرکز اعلام خسارت:
                    </strong>
                  </Center>
                  <Margin top={2}></Margin>
                  <Center>
                    <p style={ContactText}>۱۴۰۱ (بدون کد)</p>
                  </Center>
                  <Center style={{ marginTop: "-12.5px" }}>
                    <p style={ContactText}>۰۲۱-۴۱۵۵۸</p>
                  </Center>
                  <Center style={{ marginTop: "-12.5px" }}>
                    <p style={ContactText}>۸۴۲۲۹۶۵۰ – ۰۲۱ (روابط عمومی)</p>
                  </Center>
                </div>
              </Col>
              <Col
                span={14}
                style={{
                  direction: "rtl",
                  textAlign: "right",
                  backgroundColor: "#fff",
                  opacity: "90%",
                  borderRadius: "0 20px 20px 0",
                }}
              >
                <Spin spinning={loading}>
                  <Form
                    onFinish={onFinish}
                    initialValues={{ type: "0" }}
                    form={form}
                    onFinishFailed={onFinishFailed}
                  >
                    <Center>
                      <Margin top={4}>
                        <div>
                          <p className="cardTitle">
                            <strong>پیام خود را ارسال کنید.</strong>
                          </p>
                        </div>
                      </Margin>
                    </Center>
                    <Center>
                      <hr className="cardTitleHR" />
                    </Center>
                    <Margin top={3}></Margin>
                    <Row>
                      <Col span={3}></Col>
                      <Col span={18}>
                        <Form.Item
                          name="name"
                          rules={[
                            {
                              required: true,
                              message: "نام و نام خانوادگی را وارد نمایید",
                            },
                          ]}
                        >
                          <Input
                            style={contactInput}
                            placeholder="نام و نام خانوادگی"
                          />
                        </Form.Item>
                      </Col>
                      <Col span={3}></Col>
                    </Row>
                    <Margin top={3}></Margin>
                    <Row>
                      <Col span={3}></Col>
                      <Col span={18}>
                        <Form.Item
                          name="email"
                          rules={[
                            {
                              required: true,
                              message: "پست الکترونیک را وارد نمایید",
                            },
                          ]}
                        >
                          <Input
                            style={contactInput}
                            placeholder="پست الکترونیک"
                          />
                        </Form.Item>
                      </Col>
                      <Col span={3}></Col>
                    </Row>
                    <Margin top={3}></Margin>
                    <Row>
                      <Col span={3}></Col>
                      <Col span={18}>
                        <Form.Item
                          name="phone"
                          rules={[
                            {
                              validator: isNumeric,
                            },
                            {
                              required: true,
                              message: "شماره موبایل را وارد نمایید",
                            },
                          ]}
                        >
                          <Input
                            style={contactInput}
                            placeholder="شماره تماس"
                          />
                        </Form.Item>
                      </Col>
                      <Col span={3}></Col>
                    </Row>
                    <Margin top={3}></Margin>
                    <Row>
                      <Col span={3}></Col>
                      <Col span={18}>
                        <Form.Item
                          name="type"
                          rules={[
                            {
                              validator: isNumeric,
                            },
                            {
                              required: true,
                              message: "نوع پیام را انتخاب نمایید",
                            },
                          ]}
                        >
                          <Select
                            style={contactSelect}
                            defaultValue="0"
                            onChange={handleChange}
                          >
                            <Option
                              style={{
                                textAlign: "right",
                                direction: "rtl",
                                paddingRight: "30px",
                                fontFamily: "IranSans",
                                fontSize: ".9em",
                              }}
                              value="0"
                            >
                              پیشنهاد
                            </Option>
                            <Option
                              style={{
                                textAlign: "right",
                                direction: "rtl",
                                paddingRight: "30px",
                                fontFamily: "IranSans",
                                fontSize: ".9em",
                              }}
                              value="1"
                            >
                              انتقاد یا شکایت
                            </Option>
                            <Option
                              style={{
                                textAlign: "right",
                                direction: "rtl",
                                paddingRight: "30px",
                                fontFamily: "IranSans",
                                fontSize: ".9em",
                              }}
                              value="2"
                            >
                              سایر
                            </Option>
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col span={3}></Col>
                    </Row>
                    <Margin top={4}></Margin>
                    <Row>
                      <Col span={3}></Col>
                      <Col span={18}>
                        <Form.Item
                          name="message"
                          rules={[
                            {
                              required: true,
                              message: "متن پیام را وارد نمایید",
                            },
                          ]}
                        >
                          <TextArea
                            style={contactTextArea}
                            rows={6}
                            placeholder="متن پیام"
                          />
                        </Form.Item>
                      </Col>
                      <Col span={3}></Col>
                    </Row>
                    <Margin top={3}></Margin>
                    <Row>
                      <Col span={3}></Col>
                      <Col
                        span={18}
                        style={{ direction: "ltr", textAlign: "left" }}
                      >
                        <Button
                          htmlType="submit"
                          class="introBtn introBtn-white introBtn-animated"
                          style={{
                            fontSize: ".8em",
                            fontFamily: "IRANSans",
                            paddingRight: "20px",
                            paddingLeft: "20px",
                          }}
                        >
                          ارسال پیام
                        </Button>
                      </Col>
                      <Col span={3}></Col>
                    </Row>
                  </Form>
                </Spin>
              </Col>
            </Row>
          </div>
        </Col>
        <Col span={5}></Col>
      </Row>
    </div>
  ) : props.size === "tablet" ? (
    <div className="ContactUsBackground">
      <div style={{ paddingTop: "100px" }}>
        <Center>
          <p
            className="mainTitleTablet mainTitleBorderRight mainTitleBorderLeft"
            style={{ color: "#fff" }}
          >
            <strong>ارتباط با ما</strong>
          </p>
        </Center>
      </div>
      <Row style={{ marginTop: "100px" }}>
        <Col span={2}></Col>
        <Col span={20}>
          <div style={contactUsFormCard}>
            <Row>
              <Col span={10}>
                <div
                  style={{
                    backgroundColor: "#f5f5f5",
                    borderTopLeftRadius: "20px",
                  }}
                >
                  <Center>
                    <img
                      style={{ marginTop: "20px", width: "22.5%" }}
                      src={require("../../../Imgs/ContactUs/Location.png")}
                    />
                  </Center>
                  <Margin top={2}></Margin>
                  <Center>
                    <strong
                      style={{
                        fontSize: ".85em",
                        fontFamily: "IranSans",
                        textAlign: "right",
                        direction: "rtl",
                        lineHeight: 1.5,
                        color: "#535353",
                      }}
                    >
                      آدرس :
                    </strong>
                  </Center>
                  <Margin top={2}></Margin>
                  <Center>
                    <p style={ContactTextTablet}>
                    تهران، یوسف آباد،خیابان سیدجمال الدین اسدآبادی،نبش کوچه چهارم پلاک ۴۴ ساختمان ایرانیان پوشش 
                    </p>
                  </Center>
                  <Margin top={2}></Margin>
                  <Center>
                    <img
                      style={{ width: "22.5%" }}
                      src={require("../../../Imgs/ContactUs/phone.png")}
                    />
                  </Center>
                  <Margin top={2}></Margin>
                  <Center>
                    <strong
                      style={{
                        fontSize: ".85em",
                        fontFamily: "IranSans",
                        textAlign: "right",
                        direction: "rtl",
                        lineHeight: 1.5,
                        color: "#535353",
                      }}
                    >
                      تلفن تماس:
                    </strong>
                  </Center>
                  <Margin top={2}></Margin>
                  <Center>
                    <p style={ContactTextTablet}>021-84228</p>
                  </Center>
                  <Center style={{ marginTop: "-12.5px" }}>
                    <p style={ContactTextTablet}>
                      ( هزار خط ) 999 الی 84229000-021
                    </p>
                  </Center>
                  <Center style={{ marginTop: "-12.5px" }}>
                    <p style={ContactTextTablet}>فکس : ۵-۸۸۵۵۲۰۸۴-۰۲۱</p>
                  </Center>
                  <Margin top={2}></Margin>
                  <Center>
                    <img
                      style={{ width: "22.5%" }}
                      src={require("../../../Imgs/ContactUs/support.png")}
                    />
                  </Center>
                  <Margin top={2}></Margin>
                  <Center>
                    <strong
                      style={{
                        fontSize: ".85em",
                        fontFamily: "IranSans",
                        textAlign: "right",
                        direction: "rtl",
                        lineHeight: 1.5,
                        color: "#535353",
                      }}
                    >
                      مرکز اعلام خسارت:
                    </strong>
                  </Center>
                  <Margin top={2}></Margin>
                  <Center>
                    <p style={ContactTextTablet}>۱۴۰۱ (بدون کد)</p>
                  </Center>
                  <Center style={{ marginTop: "-12.5px" }}>
                    <p style={ContactTextTablet}>۰۲۱-۴۱۵۵۸</p>
                  </Center>
                  <Center style={{ marginTop: "-12.5px" }}>
                    <p style={ContactTextTablet}>۸۴۲۲۹۶۵۰ – ۰۲۱ (روابط عمومی)</p>
                  </Center>
                </div>
              </Col>
              <Col
                span={14}
                style={{
                  direction: "rtl",
                  textAlign: "right",
                  backgroundColor: "#fff",
                  opacity: "90%",
                  borderRadius: "0 20px 20px 0",
                }}
              >
                <Spin spinning={loading}>
                  <Form
                    onFinish={onFinish}
                    initialValues={{ type: "0" }}
                    form={form}
                    onFinishFailed={onFinishFailed}
                  >
                    <Center>
                      <Margin top={4}>
                        <div>
                          <p className="cardTitleTablet">
                            <strong>پیام خود را ارسال کنید.</strong>
                          </p>
                        </div>
                      </Margin>
                    </Center>
                    <Center>
                      <hr className="cardTitleHRTablet" />
                    </Center>
                    <Margin top={3}></Margin>
                    <Row>
                      <Col span={3}></Col>
                      <Col span={18}>
                        <Form.Item
                          name="name"
                          rules={[
                            {
                              required: true,
                              message: "نام و نام خانوادگی را وارد نمایید",
                            },
                          ]}
                        >
                          <Input
                            style={contactInputTablet}
                            placeholder="نام و نام خانوادگی"
                          />
                        </Form.Item>
                      </Col>
                      <Col span={3}></Col>
                    </Row>
                    <Margin top={3}></Margin>
                    <Row>
                      <Col span={3}></Col>
                      <Col span={18}>
                        <Form.Item
                          name="email"
                          rules={[
                            {
                              required: true,
                              message: "پست الکترونیک را وارد نمایید",
                            },
                          ]}
                        >
                          <Input
                            style={contactInputTablet}
                            placeholder="پست الکترونیک"
                          />
                        </Form.Item>
                      </Col>
                      <Col span={3}></Col>
                    </Row>
                    <Margin top={3}></Margin>
                    <Row>
                      <Col span={3}></Col>
                      <Col span={18}>
                        <Form.Item
                          name="phone"
                          rules={[
                            {
                              validator: isNumeric,
                            },
                            {
                              required: true,
                              message: "شماره موبایل را وارد نمایید",
                            },
                          ]}
                        >
                          <Input
                            style={contactInputTablet}
                            placeholder="شماره تماس"
                          />
                        </Form.Item>
                      </Col>
                      <Col span={3}></Col>
                    </Row>
                    <Margin top={3}></Margin>
                    <Row>
                      <Col span={3}></Col>
                      <Col span={18}>
                        <Form.Item
                          name="type"
                          rules={[
                            {
                              validator: isNumeric,
                            },
                            {
                              required: true,
                              message: "نوع پیام را انتخاب نمایید",
                            },
                          ]}
                        >
                          <Select
                            style={contactSelect}
                            defaultValue="0"
                            onChange={handleChange}
                          >
                            <Option style={contactInputTablet} value="0">
                              پیشنهاد
                            </Option>
                            <Option style={contactInputTablet} value="1">
                              انتقاد یا شکایت
                            </Option>
                            <Option style={contactInputTablet} value="2">
                              سایر
                            </Option>
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col span={3}></Col>
                    </Row>
                    <Margin top={4}></Margin>
                    <Row>
                      <Col span={3}></Col>
                      <Col span={18}>
                        <Form.Item
                          name="message"
                          rules={[
                            {
                              required: true,
                              message: "متن پیام را وارد نمایید",
                            },
                          ]}
                        >
                          <TextArea
                            style={contactTextArea}
                            rows={6}
                            placeholder="متن پیام"
                          />
                        </Form.Item>
                      </Col>
                      <Col span={3}></Col>
                    </Row>
                    <Margin top={3}></Margin>
                    <Row>
                      <Col span={3}></Col>
                      <Col
                        span={18}
                        style={{ direction: "ltr", textAlign: "left" }}
                      >
                        <Button
                          htmlType="submit"
                          class="introBtn introBtn-white introBtn-animated"
                          style={{
                            fontSize: ".7em",
                            fontFamily: "IRANSans",
                            paddingRight: "20px",
                            paddingLeft: "20px",
                          }}
                        >
                          ارسال پیام
                        </Button>
                      </Col>
                      <Col span={3}></Col>
                    </Row>
                  </Form>
                </Spin>
              </Col>
            </Row>
          </div>
        </Col>
        <Col span={2}></Col>
      </Row>
    </div>
  ) : (
    <div className="ContactUsBackground">
      <div style={{ paddingTop: "50px" }}>
        <Center>
          <p
            className="mainTitleMobile mainTitleBorderRightMobile mainTitleBorderLeftMobile"
            style={{ color: "#fff" }}
          >
            <strong>ارتباط با ما</strong>
          </p>
        </Center>
      </div>
      <Row style={{ marginTop: "75px" }}>
        <Col span={1}></Col>
        <Col
          span={22}
          style={{
            direction: "rtl",
            textAlign: "right",
            backgroundColor: "#f9f9f9",
            opacity: "90%",
            borderRadius: "20px",
          }}
        >
          <Spin spinning={loading}>
            <Form
              onFinish={onFinish}
              initialValues={{ type: "0" }}
              form={form}
              onFinishFailed={onFinishFailed}
            >
              <Center>
                <Margin top={4}>
                  <div>
                    <p className="cardTitleMobile">
                      <strong>پیام خود را ارسال کنید.</strong>
                    </p>
                  </div>
                </Margin>
              </Center>
              <Center>
                <hr
                  className="cardTitleHRMobile"
                  style={{ marginTop: "-10px" }}
                />
              </Center>
              <Margin top={3}></Margin>
              <Row>
                <Col span={3}></Col>
                <Col span={18}>
                  <Form.Item
                    name="name"
                    rules={[
                      {
                        required: true,
                        message: "نام و نام خانوادگی را وارد نمایید",
                      },
                    ]}
                  >
                    <Input
                      style={contactInputMobile}
                      placeholder="نام و نام خانوادگی"
                    />
                  </Form.Item>
                </Col>
                <Col span={3}></Col>
              </Row>
              <Margin top={3}></Margin>
              <Row>
                <Col span={3}></Col>
                <Col span={18}>
                  <Form.Item
                    name="email"
                    rules={[
                      {
                        required: true,
                        message: "پست الکترونیک را وارد نمایید",
                      },
                    ]}
                  >
                    <Input
                      style={contactInputMobile}
                      placeholder="پست الکترونیک"
                    />
                  </Form.Item>
                </Col>
                <Col span={3}></Col>
              </Row>
              <Margin top={3}></Margin>
              <Row>
                <Col span={3}></Col>
                <Col span={18}>
                  <Form.Item
                    name="phone"
                    rules={[
                      {
                        validator: isNumeric,
                      },
                      {
                        required: true,
                        message: "شماره موبایل را وارد نمایید",
                      },
                    ]}
                  >
                    <Input
                      style={contactInputMobile}
                      placeholder="شماره تماس"
                    />
                  </Form.Item>
                </Col>
                <Col span={3}></Col>
              </Row>
              <Margin top={3}></Margin>
              <Row>
                <Col span={3}></Col>
                <Col span={18}>
                  <Form.Item
                    name="type"
                    rules={[
                      {
                        validator: isNumeric,
                      },
                      {
                        required: true,
                        message: "نوع پیام را انتخاب نمایید",
                      },
                    ]}
                  >
                    <Select
                      style={contactSelectMobile}
                      defaultValue="0"
                      onChange={handleChange}
                    >
                      <Option style={contactInputMobile} value="0">
                        پیشنهاد
                      </Option>
                      <Option style={contactInputMobile} value="1">
                        انتقاد یا شکایت
                      </Option>
                      <Option style={contactInputMobile} value="2">
                        سایر
                      </Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={3}></Col>
              </Row>
              <Margin top={4}></Margin>
              <Row>
                <Col span={3}></Col>
                <Col span={18}>
                  <Form.Item
                    name="message"
                    rules={[
                      {
                        required: true,
                        message: "متن پیام را وارد نمایید",
                      },
                    ]}
                  >
                    <TextArea
                      style={contactTextArea}
                      rows={6}
                      placeholder="متن پیام"
                    />
                  </Form.Item>
                </Col>
                <Col span={3}></Col>
              </Row>
              <Margin top={3}></Margin>
              <Row>
                <Col span={3}></Col>
                <Col span={18} style={{ direction: "ltr", textAlign: "left" }}>
                  <Button
                    htmlType="submit"
                    class="introBtn introBtn-white introBtn-animated"
                    style={{
                      fontSize: ".7em",
                      fontFamily: "IRANSans",
                      paddingRight: "20px",
                      paddingLeft: "20px",
                    }}
                  >
                    ارسال پیام
                  </Button>
                  <Margin bottom={3}></Margin>
                </Col>
                <Col span={3}></Col>
              </Row>
            </Form>
          </Spin>
        </Col>
        <Col span={1}></Col>
      </Row>
      <Margin top={3}></Margin>
      <Row>
        <Col span={1}></Col>
        <Col span={22}>
          <div style={{ backgroundColor: "#f5f5f5", borderRadius: "20px" }}>
            <Center>
              <img
                style={{ marginTop: "20px", width: "15%" }}
                src={require("../../../Imgs/ContactUs/Location.png")}
              />
            </Center>
            <Margin top={2}></Margin>
            <Center>
              <strong
                style={{
                  fontSize: ".85em",
                  fontFamily: "IranSans",
                  textAlign: "right",
                  direction: "rtl",
                  lineHeight: 1.5,
                  color: "#535353",
                }}
              >
                آدرس :
              </strong>
            </Center>
            <Margin top={2}></Margin>
            <Center>
                    <p style={ContactTextMobile}>
                    ۱-ساختمان دفتر مديرعامل و معاونت نواوري و اقتصادي
تهران :
<br/>
يوسف آباد، بالاتر از ميدان سلماس خيابان شهريار نبش خيابان چهاردهم  پلاك ٣٩ 
                    </p>
                  </Center>
                  <Center>
                    <p style={ContactTextMobile}>

                    ۲.ساختمان معاونت فني و امور مشتريان:
                    <br/>
تهران:يوسف آباد ، خيابان اسد آبادي نبش خيابان چهارم پلاک ۴۴                    </p>
                  </Center>
                  <Center>
                    <p style={ContactTextMobile}>
                    ۳-ساختمان اداری:
                    <br/>
 یوسف آباد خیابان اسدآبادی کوچه هفتم پلاک ۱۴ 

                    </p>
                  </Center>
                  <Center>
                    <p style={ContactTextMobile}>
                      ۴-ساختمان مرکزی:
                      <br/>
                      مطهری ، کوه نور ، انتهای خیابان چهارم و ششم  پلاک ۱۵  و ۱۶ (تعطیل به علت ساخت و ساز)
                    </p>
                  </Center>
                  <Center>
                  <p style={ContactTextMobile}>
                      ۵-ساختمان فاطمی:
                      <br/>
                      فاطمی کوچه دوم جنب بیمه ایران پلاک ۱۳
                    </p>
                  </Center>
            <Margin top={2}></Margin>
            <Center>
              <img
                style={{ width: "15%" }}
                src={require("../../../Imgs/ContactUs/phone.png")}
              />
            </Center>
            <Margin top={2}></Margin>
            <Center>
              <strong
                style={{
                  fontSize: ".85em",
                  fontFamily: "IranSans",
                  textAlign: "right",
                  direction: "rtl",
                  lineHeight: 1.5,
                  color: "#535353",
                }}
              >
                تلفن تماس:
              </strong>
            </Center>
            <Margin top={2}></Margin>
            <Center>
              <p style={ContactTextMobile}>021-84228</p>
            </Center>
            <Center style={{ marginTop: "-12.5px" }}>
              <p style={ContactTextMobile}>( هزار خط ) 999 الی 84229000-021</p>
            </Center>
            <Center style={{ marginTop: "-12.5px" }}>
              <p style={ContactTextMobile}>فکس : ۵-۸۸۵۵۲۰۸۴-۰۲۱</p>
            </Center>
            <Margin top={2}></Margin>
            <Center>
              <img
                style={{ width: "15%" }}
                src={require("../../../Imgs/ContactUs/support.png")}
              />
            </Center>
            <Margin top={2}></Margin>
            <Center>
              <strong
                style={{
                  fontSize: ".85em",
                  fontFamily: "IranSans",
                  textAlign: "right",
                  direction: "rtl",
                  lineHeight: 1.5,
                  color: "#535353",
                }}
              >
                مرکز اعلام خسارت:
              </strong>
            </Center>
            <Margin top={2}></Margin>
            <Center>
              <p style={ContactTextMobile}>۱۴۰۱ (بدون کد)</p>
            </Center>
            <Center style={{ marginTop: "-12.5px" }}>
              <p style={ContactTextMobile}>۰۲۱-۴۱۵۵۸</p>
            </Center>
            <Center style={{ marginTop: "-12.5px" }}>
              <p style={ContactTextMobile}>۸۴۲۲۹۶۵۰ – ۰۲۱ (روابط عمومی)</p>
            </Center>
          </div>
        </Col>
        <Col span={1}></Col>
      </Row>
    </div>
  );
};

export default CentralAddress;
